export default function initMenu() {
    "use strict";

    const __menu = {
        init: function () {
            this.menuHover();
            this.scrollHeader();

            window.openLevel = this.openLevel.bind(this);
            window.goBack = this.goBack.bind(this);
            window.returnToMain = this.returnToMain.bind(this);
        },

        openLevel: function (levelId) {
            const currentActive = document.querySelector('.header__mobile--content.active');
            const nextLevel = document.getElementById(levelId);
            if (!nextLevel) return;

            const wrapper = document.querySelector('.header__mobile--wrapper');
            if (wrapper && !wrapper.classList.contains('border-bottom')) {
                wrapper.classList.add('border-bottom');
            }

            currentActive.classList.remove('active');
            nextLevel.classList.add('active');



            this.updateHeader(nextLevel);
        },


        goBack: function (currentLevelId, previousLevelId) {
            const currentLevel = document.getElementById(currentLevelId);
            const previousLevel = document.getElementById(previousLevelId);

            currentLevel.classList.remove('active');
            previousLevel.classList.add('active');

            this.updateHeader(previousLevel);
        },

        returnToMain: function () {
            const wrapper = document.querySelector('.header__mobile--wrapper');
            wrapper.classList.remove("border-bottom");
            document.querySelectorAll('.header__mobile--content').forEach(level =>
                level.classList.remove('active')
            );
            const firstLevel = document.getElementById('level_0');
            if (firstLevel) {
                firstLevel.classList.add('active');
                this.updateHeader(firstLevel);
            }
        },

        updateHeader: function (levelElement) {
            const wrapper = document.querySelector('.header__mobile--wrapper');
            if (!wrapper || !levelElement) return;

            const level = parseInt(levelElement.dataset.level, 10);
            const title = levelElement.dataset.title || '';
            const parentId = levelElement.dataset.parent || '';

            if (level === 1) {
                // Livello principale → mostra logo e hamburger
                wrapper.innerHTML = `
            <a href="/" target="_blank" rel="noopener noreferrer" class="logo" title="Homepage">
                <img class="logo-icon" src="${window.themeLogoURL}" alt="Logo FSR" />
            </a>
            <div class="header__mobile--btnOpen">
                <svg class="svgOpen d-none" width="48" height="23" viewBox="0 0 48 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.30762 1.69232H23.3076" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    <path d="M1.30762 10.1539H18.2307" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    <path d="M1.30762 18.6154H23.3076" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    <path d="M42.6154 9.30769C42.6154 13.8959 38.8959 17.6154 34.3077 17.6154C29.7195 17.6154 26 13.8959 26 9.30769C26 4.71948 29.7195 1 34.3077 1C38.8959 1 42.6154 4.71948 42.6154 9.30769Z" stroke="white" stroke-width="2"/>
                    <path class="handle" d="M46.2926 22.7071C46.6831 23.0976 47.3163 23.0976 47.7068 22.7071C48.0973 22.3166 48.0973 21.6834 47.7068 21.2929L46.2926 22.7071ZM39.5234 15.9379L46.2926 22.7071L47.7068 21.2929L40.9376 14.5237L39.5234 15.9379Z" fill="white"/>
                </svg>
                <i class="svgClose fa-sharp-duotone fa-light fa-xmark fa-2x"></i>
            </div>
        `;
            } else {
                // Sottomenu → mostra back + titolo + chiusura
                wrapper.innerHTML = `
            <div class="submenu-header d-flex align-items-center justify-content-between w-100">
                <span class="back" onclick="goBack('${levelElement.id}', '${parentId}')"><i class="fa-light fa-chevron-left fa-lg" aria-hidden="true"></i></span>
                <h3 class="mb-0">${title}</h3>
                <i class="close fa-sharp-duotone fa-light fa-xmark fa-2x" onclick="returnToMain()"></i>
            </div>
        `;
            }

            // 🔁 Ricollega il listener ogni volta che sostituisci l'header
            if (typeof window.bindMenuToggle === 'function') {
                window.bindMenuToggle();
            }
        },

        /*
        ==============================================
           MENU HOVER
        ==============================================
        */
        menuHover: function () {
            const HEADER = document.querySelector('header');
            //const MENU_ELEMENTS = document.querySelectorAll('.main-nav > li');

            // → 1) prendi tutti i menu-item tranne il search-button
            const MENU_ELEMENTS = Array.from(document.querySelectorAll('.main-nav > li'))
                .filter(li => !li.classList.contains('itemid-search-button'));

            const SUBMENU = document.querySelector('.mega-menu-outer');
            const HEADER_WRAPPER = document.querySelector('.header__wrapper');
            const hoverLine = document.createElement('span');
            hoverLine.classList.add('menu-hover-line');
            let HOVERED = { __item: null, __subMenuItem: null };
            let showSubmenuTimeout, delayedDeactivateTimeout;
            let isHeaderWrapperHovered = false;
            let searchOpen = false;

            // → 2) prendi separatamente il search-trigger e il relativo submenu
            const SEARCH_TRIGGER = document.querySelector('.main-nav > li.itemid-search-button');
            const SEARCH_SUBMENU = document.getElementById('itemid-search-button');

            // Aggiungi hover line al contenitore del menu
            const navContainer = document.querySelector('.main-nav').closest('nav');
            navContainer.appendChild(hoverLine);
            navContainer.style.position = 'relative';

            // Sposta l'hover line
            function moveHoverLineTo(target) {
                hoverLine.classList.remove('hidden');
                hoverLine.style.transform = `translateX(${target.offsetLeft}px)`;
                hoverLine.style.width = `${target.offsetWidth}px`;
            }

            // Cambia l'elemento attivo
            function changeActiveItem(item, subMenuItem) {
                HOVERED = { __item: item, __subMenuItem: subMenuItem };
                //showSubmenuTimeout = setTimeout(() => checkHovered(), 350);
                checkHovered();
            }

            // Disattiva il menu
            function deactivateMenu() {
                const submenuItems = SUBMENU.querySelectorAll('.mega-menu-items');
                submenuItems.forEach(item => item.classList.remove('shown'));
                SUBMENU.style.height = '0px';
                hoverLine.classList.add('hidden');
                HEADER.classList.remove('dark-bgr-show');
                searchOpen = false;
            }

            // Controlla l'elemento attivo
            function checkHovered() {
                if (HEADER.classList.contains('light') && HOVERED.__item) {
                    moveHoverLineTo(HOVERED.__item);
                    if (!HOVERED.__item.classList.contains('no-articles')) {
                        const submenuItems = SUBMENU.querySelectorAll('.mega-menu-items');
                        submenuItems.forEach(item => item.classList.remove('shown'));
                        HOVERED.__subMenuItem?.classList.add('shown');
                        SUBMENU.style.height = `${HOVERED.__subMenuItem?.offsetHeight || 0}px`;
                    } else {
                        SUBMENU.style.height = '0px';
                    }
                }
                if (HOVERED.__item) {
                    HEADER.classList.add('dark-bgr-show');
                }
            }


            // Attiva il comportamento hover su ogni elemento del menu
            MENU_ELEMENTS.forEach(mainMenuItem => {

                const activatorClass = Array.from(mainMenuItem.classList).find(c => c.startsWith('itemid-'));
                const subMenuItem = document.getElementById(activatorClass);

                mainMenuItem.addEventListener('mouseenter', () => {
                    if (searchOpen) return;
                    changeActiveItem(mainMenuItem, subMenuItem);
                    isHeaderWrapperHovered = true;
                    clearTimeout(delayedDeactivateTimeout);
                });

                mainMenuItem.addEventListener('mouseleave', () => {
                    if (searchOpen) return;
                    clearTimeout(showSubmenuTimeout);
                    isHeaderWrapperHovered = false;
                    delayedDeactivate();
                });

            });

            // ─── click sul pulsante ricerca ───
            if (SEARCH_TRIGGER && SEARCH_SUBMENU) {
                const searchIcon = SEARCH_TRIGGER.querySelector('i.search__button');
                SEARCH_TRIGGER.style.cursor = 'pointer';
                SEARCH_TRIGGER.addEventListener('click', e => {
                    e.preventDefault();
                    if (searchOpen) {
                        // se già aperto, chiudo
                        deactivateMenu();
                        changeActiveItem(null, null);

                        // Ripristino le classi originali
                        searchIcon.classList.remove('fa-solid','fa-lg','fa-xmark');
                        searchIcon.classList.add('fa-sharp','fa-light','fa-magnifying-glass');

                    } else {
                        // apro solo il submenu di ricerca, ignoro hover/leave
                        searchOpen = true;
                        changeActiveItem(SEARCH_TRIGGER, SEARCH_SUBMENU);

                        // forza altezza full viewport
                        //SUBMENU.style.height = '100vh';
                        // opzionale: scrollbar interna se serve
                        //SUBMENU.style.overflowY = 'auto';

                        // Cambio le classi dell'icona
                        searchIcon.classList.remove('fa-sharp','fa-light','fa-magnifying-glass');
                        searchIcon.classList.add('fa-solid','fa-lg','fa-xmark');
                    }
                });
            }

            // Gestione dell'hover sull'intestazione
            HEADER.addEventListener('mouseenter', () => {
                if (searchOpen) return;
                //setTimeout(() => {
                    HEADER.classList.add('light');
                    checkHovered();
                //}, 200);
            });

            HEADER.addEventListener('mouseleave', () => {
                if (searchOpen) return;
                HEADER.classList.remove('light');
                deactivateMenu();
                changeActiveItem(null, null);
            });

            // Ritardo nella disattivazione del menu
            function delayedDeactivate() {
                delayedDeactivateTimeout = setTimeout(() => {
                    if (!isHeaderWrapperHovered && !searchOpen) {
                        deactivateMenu();
                    }
                }, 200);
            }

            HEADER_WRAPPER?.addEventListener('mouseenter', () => {
                if (searchOpen) return;
                isHeaderWrapperHovered = true;
                clearTimeout(delayedDeactivateTimeout);
            });

            HEADER_WRAPPER?.addEventListener('mouseleave', () => {
                if (searchOpen) return;
                isHeaderWrapperHovered = false;
                delayedDeactivate();
            });
        },

        /*
        ==============================================
           REDUCE HEADER ON SCROLL
        ==============================================
        */
        scrollHeader: function () {
            let lastScrollTop = 0; // Variabile per memorizzare l'ultima posizione dello scroll

            window.addEventListener('scroll', () => {
                const currentScroll = window.scrollY || document.documentElement.scrollTop;

                // Se siamo in cima alla pagina, rimuovi entrambe le classi
                if (currentScroll === 0) {
                    document.body.classList.remove('going-down', 'going-up');
                    return; // Esci dalla funzione
                }

                if (currentScroll > lastScrollTop) {
                    // Scroll verso il basso
                    document.body.classList.add('going-down');
                    document.body.classList.remove('going-up');
                } else {
                    // Scroll verso l'alto
                    document.body.classList.add('going-up');
                    document.body.classList.remove('going-down');
                }

                // Aggiorna la posizione precedente
                lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Previene valori negativi
            });
        },

    };

    // Inizializza il menu
    __menu.init();
}
